module.exports = __webpack_public_path__ + "img/tick.d051d4b.svg";